import React from "react";
import withRoot from "../withRoot";
import Layout from "../components/Layout";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import PlayArrowRounded from "@material-ui/icons/PlayArrowRounded";
import PauseRounded from "@material-ui/icons/PauseRounded";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core";
import { red, grey } from "@material-ui/core/colors";
import Collapse from "@material-ui/core/Collapse";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OpenInNew from "@material-ui/icons/OpenInNew";

import * as gym from "gym-js";
import { textModel } from "../data/models/default";

import classnames from "classnames";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-okaidia.css";

const styles = theme => ({
  modelCode: {
    margin: 24
  },
  game: {},
  error: {
    backgroundColor: red[700]
  },
  icon: {
    fontSize: 20
  },
  infoBlock: {
    maxWidth: 500,
    marginBottom: 20
  },
  textEditor: {
    backgroundColor: grey[400],
    minHeight: 640
  },
  settings: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  settingsOpen: {
    transform: "rotate(180deg)"
  },
  settingsBox: {
    padding: 16
  },
  form: {
    display: "flex",
    flexWrap: "wrap"
  },
  formItem: {
    margin: 12,
    flexGrow: 1
  }
});

class Env extends React.Component {
  constructor(props) {
    super(props);
    const { Env } = this.props.pageContext;

    this.state = {
      game: "",
      code: textModel,
      snackOpen: false,
      snackMessage: "",
      running: false,
      showSettings: false,
      gameSettings: Env.defaults
    };
  }

  componentDidMount() {
    this.createGame();
  }

  createGame = () => {
    const { Env } = this.props.pageContext;
    const { gameSettings } = this.state;
    if (gameSettings !== null)
      this.game = new gym[Env.env](...gameSettings);
    else
      this.game = new gym[Env.env]();

    this.game.render("html");
    if (!Env.phaser) {
      this.game.reset();
      this.setState({ game: this.game.renderHTML() });
    } else {
      this.game.reset({
        width: 304,
        height: 304
      });
    }
    this.done = false;
    this.renderFromCode = false;
    global.env = this.game;
    if (Env.phaser) // This is to ensure phaser games don't run on auto
      setTimeout(()=>this.game.game.loop.sleep(), 200);
  };

  update = () => {
    const {Env} = this.props.pageContext;
    if (!this.done) {
      if (!Env.phaser)
        this.setState({ game: this.game.renderHTML() });
      let action = this.game.action_space.sample();
      let stepInfo = this.game.step(action);
      this.done = stepInfo[2];
      if (Env.phaser)
        stepInfo[0].dispose();
    } else {
      if (!Env.phaser){
        this.setState({ game: this.game.renderHTML() + "\nGame Over!" });
        this.game.reset()
      } else {
        this.game.reset().dispose();
      }
      this.done = false;
    }
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  updateModelCode = code => {
    this.setState({ code: code });
  };

  deployModel = () => {
    const { code } = this.state;
    const { Env } = this.props.pageContext;
    try {
      // eslint-disable-next-line
      eval(code);
      if (!Env.phaser)
        this.setState({ game: this.game.renderHTML() });
    } catch (error) {
      this.showSnackbar(error);
    }
  };

  showSnackbar = error => {
    this.setState({
      snackOpen: true,
      snackMessage: String(error.message)
    });
  };

  snackClose = () => {
    this.setState({
      snackOpen: false,
      snackMessage: ""
    });
  };

  stopGame = () => {
    if (this.state.running) {
      clearInterval(this.interval);
      this.setState({ running: false });
    } else {
      this.interval = setInterval(this.update, 500);
      this.setState({ running: true });
    }
  };

  toggleSettings = () => {
    this.setState({ showSettings: !this.state.showSettings });
  };

  handleSettingsChange = i => async event => {
    const { gameSettings } = this.state;
    let newSettings = gameSettings.slice();
    const {value} = event.target;
    if (isNaN(value) || typeof value === "boolean")
      newSettings[i] = value;
    else
      newSettings[i] = Number(value);

    await this.setState({
      gameSettings: newSettings
    });
    this.createGame();
  };

  render() {
    const { classes } = this.props;
    const { Env } = this.props.pageContext;
    const { snackOpen, snackMessage, running, showSettings, gameSettings } = this.state;
    return (
      <Layout
        scripts={
          <script
            src="https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@1.2.2/dist/tf.min.js"
            async
            defer
          />
        }
      >
        <Grid container alignItems="stretch" justify="center" spacing={24}>
          <Grid item md={12}>
            <Typography variant="h1">{Env.name}</Typography>
          </Grid>
          <Grid item md={8} sm={9}>
            <Card raised className={classes.textEditor}>
              <CardActions>
                <Grid container justify="flex-end">
                  <Button
                    size="small"
                    onClick={this.deployModel}
                    color="primary"
                  >
                    Run Code
                  </Button>
                </Grid>
              </CardActions>
              <Divider />
              <CardContent>
                <Editor
                  value={this.state.code}
                  onValueChange={this.updateModelCode}
                  highlight={code => highlight(code, languages.js)}
                  padding={10}
                  style={{
                    fontFamily: '"Fira code", "Fira Mono", monospace',
                    fontSize: 16
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={4} sm={3} xs={12}>
            <Card>
              <CardContent>
                <Typography
                  component="div"
                  variant="body1"
                  className={classes.game}
                >
                  <Grid
                    item
                    id="gym-environment"
                    dangerouslySetInnerHTML={{ __html: this.state.game }}
                  />
                </Typography>
              </CardContent>
              <Divider />
              <CardActions>
                <Grid container justify="space-between" alignItems="center">
                <Grid item>
                  <Tooltip title="Run with Random Actions">
                    <IconButton onClick={this.stopGame}>
                      {running ? <PauseRounded /> : <PlayArrowRounded />}
                    </IconButton>
                  </Tooltip>
                  <a
                    href={`https://ttumiel.github.io/gym.js/classes/${Env.slug}.html`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button size="small" color="primary">
                      Docs
                      <OpenInNew />
                    </Button>
                  </a>
                  </Grid>
                  <Grid item>
                  <IconButton
                    className={classnames(classes.showSettings, {
                      [classes.settingsOpen]: showSettings
                    })}
                    onClick={this.toggleSettings}
                    aria-expanded={showSettings}
                    aria-label="Show more"
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                  </Grid>
                </Grid>
              </CardActions>
              <Collapse in={showSettings} timeout="auto" unmountOnExit>
                <CardContent>
                  <Typography variant="h3" align="left">
                    Settings:
                  </Typography>
                  <Typography
                    align="left"
                    component="div"
                    className={classes.settingsBox}
                  >
                    <form className={classes.form} autoComplete="off">
                      {Env.settings &&
                        Env.settings.map((setting,i) => {
                          if (Array.isArray(setting.values)) {
                            return (
                              <FormControl className={classes.formItem} key={i}>
                                <InputLabel htmlFor={`${setting.name}-helper`}>
                                  {setting.name}
                                </InputLabel>
                                <Select
                                  value={gameSettings[i]}
                                  onChange={this.handleSettingsChange(i)}
                                  input={
                                    <Input
                                      name={setting.name}
                                      value={gameSettings[i]}
                                      id={`${setting.name}-helper`}
                                    />
                                  }
                                >
                                  {setting.values.map(v => (
                                    <MenuItem value={v} key={v}>{String(v)}</MenuItem>
                                  ))}
                                </Select>
                                <FormHelperText
                                  id={`${setting.name}-helper-text`}
                                >
                                  {setting.helpText}
                                </FormHelperText>
                              </FormControl>
                            );
                          } else if (typeof setting === "object") {
                            return (
                              <FormControl className={classes.formItem} key={i}>
                                <InputLabel htmlFor={`${setting.name}-helper`}>
                                  {setting.name}
                                </InputLabel>
                                <Input
                                  key={i}
                                  className={classes.input}
                                  value={gameSettings[i]}
                                  margin="dense"
                                  onChange={this.handleSettingsChange(i)}
                                  id={`${setting.name}-helper`}
                                  inputProps={{
                                    step: (setting.values.max-setting.values.min)/10,
                                    min: setting.values.min,
                                    max: setting.values.max,
                                    type: "number",
                                    "aria-labelledby": setting.name
                                  }}
                                />
                                <FormHelperText
                                  id={`${setting.name}-helper-text`}
                                >
                                  {setting.helpText}
                                </FormHelperText>
                              </FormControl>
                            );
                          } else {
                            return null;
                          }
                        })}

                      {Env.settings === null && (
                        <Typography variant="body1">
                          This environment currently does not have changeable
                          settings.
                        </Typography>
                      )}
                    </form>
                  </Typography>
                </CardContent>
              </Collapse>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          open={snackOpen}
          autoHideDuration={6000}
          onClose={this.snackClose}
        >
          <SnackbarContent
            aria-describedby="snackbar"
            message={snackMessage}
            className={classes.error}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.snackClose}
              >
                <CloseIcon className={classes.icon} />
              </IconButton>
            ]}
          />
        </Snackbar>
      </Layout>
    );
  }
}

export default withRoot(withStyles(styles)(Env));
